import React from "react";
import { Content } from "@worcket/common/components/layout";
import { withTranslation } from "react-i18next";
import { Row, Tooltip, message, Tabs, Icon } from "antd";
import copy from "copy-to-clipboard";
import { Route } from "react-router-dom";
import { compose } from "recompose";

import { httpToHttps } from "../../utils/images";
import Page from "../../components/display/Page";
import Header from "../../components/structure/Header";
import UniversityList from "../../components/List/UniversityList";
import CompanyList from "../../components/List/CompanyList";
import { getCompanyURL } from "../../utils/urls";
import Button from "../../components/Button";
import Analytics from "../Analytics";

import ProfileForm from "./ProfileForm";
import UsersList from "./UsersList";
import SocialAccounts from "./SocialAccounts";
import SiteConfig from "./SiteConfig/SiteConfig";
import TestPayments from "./TestPayments";

import styled from "styled-components/macro";

const { TabPane } = Tabs;

const StyledTabs = styled(Tabs)`
  margin: 16px !important;

  &.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    margin-right: 4px;
    min-width: fit-content;
    padding: 0 24px;
  }

  .ant-tabs-tab-active {
    background: #fff;
    border-color: #fff !important;
  }

  .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-tabpane {
    background: #fff;
    padding: 24px 16px !important;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

const Company = ({ t, match: routeMatch, company, isHeadquarter = false }) => {
  const companyURL = getCompanyURL(company.name);
  return (
    <Page>
      <Content>
        <Row
          type="flex"
          justify="space-between"
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <Header
            image={httpToHttps(company.logo)}
            title={company.name}
            subtitle={company.slogan}
          />
          <Right>
            <Tooltip placement="top" title={t("company:site.copyLinkTooltip")}>
              <Button
                icon="link"
                type="quaternary"
                onClick={() => {
                  copy(companyURL);
                  message.success(t("company:site.linkCopied"));
                }}
              >
                {t("company:site.copyLink")}
              </Button>
            </Tooltip>
          </Right>
        </Row>
      </Content>
      <Route
        path={`${routeMatch.url}/:tab?`}
        render={({ match: tabMatch, history }) => {
          return (
            <StyledTabs
              defaultActiveKey={tabMatch.params.tab}
              animated={false}
              type="card"
              onChange={key => {
                history.push(`${routeMatch.url}/${key}`);
              }}
            >
              <TabPane
                tab={
                  <span>
                    <Icon type="setting" />
                    {t("company:tabs.profile")}
                  </span>
                }
                key="perfil"
              >
                <ProfileForm profile={company} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="team" />
                    {t("company:tabs.users")}
                  </span>
                }
                key="usuarios"
              >
                <UsersList
                  users={company.users}
                  isHeadquarter={company.isHeadquarter}
                />
              </TabPane>
              {false && !isHeadquarter && (
                <TabPane
                  tab={
                    <span>
                      <Icon type="bar-chart" />
                      {t("company:tabs.balance")}
                    </span>
                  }
                  key="balance"
                >
                  <TestPayments />
                </TabPane>
              )}
              {!isHeadquarter && (
                <TabPane
                  tab={
                    <span>
                      <Icon type="link" />
                      {t("company:tabs.socialMedia")}
                    </span>
                  }
                  key="redes-sociales"
                >
                  <SocialAccounts accounts={company.socialAccounts} />
                </TabPane>
              )}
              {!isHeadquarter &&
                (company.type === "university" ? (
                  <TabPane
                    tab={
                      <span data-test="company-list-tab">
                        <Icon type="read" />
                        {t("company:tabs.vinculations")}
                      </span>
                    }
                    key="vinculations"
                  >
                    {/* Lista solicitudes de vinculación */}
                    <CompanyList />
                  </TabPane>
                ) : (
                  <TabPane
                    tab={
                      <span data-test="university-list-tab">
                        <Icon type="read" />
                        {t("company:tabs.universities")}
                      </span>
                    }
                    key="universidades"
                  >
                    {/* Lista universidades para vincular */}
                    <UniversityList type="list" />
                  </TabPane>
                ))}
              <TabPane
                tab={
                  <span>
                    <Icon type="bg-colors" />
                    {t("company:tabs.jobsPage")}
                  </span>
                }
                key="bolsa-de-empleo"
              >
                <SiteConfig companyURL={companyURL} company={company} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="line-chart" />
                    {t("company:tabs.analytics")}
                  </span>
                }
                key="analytics"
              >
                <Analytics company={company} />
              </TabPane>
            </StyledTabs>
          );
        }}
      />
    </Page>
  );
};

const enhancer = compose(withTranslation(["company"]));

export default enhancer(Company);
